// Employee Document Folder service (per Mudassir's Jun-17 handoff).
// Master document record for an employee; completed hiring packages are linked
// in after applicant-to-employee conversion.
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const employeeDocumentFolderService = {
  // HR Received Documents list: employees who already have a document folder.
  getEmployeesWithFolders: async () => {
    const res = await axiosInstance.get(API.employeeDocumentFolder.getEmployees);
    return res.data;
  },

  // Full document folder for one employee (used by Received Documents and the
  // Employee Detail Documents tab).
  getByEmployee: async (employeeId) => {
    const res = await axiosInstance.get(API.employeeDocumentFolder.getByEmployee(employeeId));
    return res.data;
  },

  // The logged-in employee's own document folder (Employee Dashboard Documents
  // page). Resolves to the current user from the auth token.
  getMine: async () => {
    const res = await axiosInstance.get(API.employeeDocumentFolder.getMine);
    return res.data;
  },
};

export default employeeDocumentFolderService;
